import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed",
  style: {"background-image":"url('https://images.empoweredconsumerism-static-files.com/iglow_dtc/iglow_bg.jpg')","-webkit-background-size":"cover","-moz-background-size":"cover","-o-background-size":"cover","background-size":"cover"}
}
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "mb-12"
}, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Logo",
    src: "https://images.empoweredconsumerism-static-files.com/iglow_dtc/iglow_logo.png",
    class: "h-175px"
  })
], -1)
const _hoisted_4 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "text-dark mb-3" }, " Sign In "),
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-4" }, [
    /*#__PURE__*/_createTextVNode(" New Here? "),
    /*#__PURE__*/_createVNode("a", {
      class: "link-primary fw-bolder",
      "data-bs-toggle": "modal",
      "data-bs-target": `#kt_register_account_modal_ec`,
      style: {"cursor":"pointer"}
    }, " Register ")
  ])
], -1)
const _hoisted_6 = { class: "fv-row mb-10" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Username", -1)
const _hoisted_8 = { class: "fv-plugins-message-container" }
const _hoisted_9 = { class: "fv-help-block" }
const _hoisted_10 = { class: "fv-row mb-10" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-stack mb-2" }, [
  /*#__PURE__*/_createVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0" }, "Password")
], -1)
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " Continue ", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-center flex-column-auto p-10" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_Form = _resolveComponent("Form")
  const _component_RegisterAccountModalEC = _resolveComponent("RegisterAccountModalEC")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Form, {
            class: "form w-100",
            id: "kt_login_signin_form",
            onSubmit: _ctx.onSubmitLogin,
            "validation-schema": _ctx.login
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg form-control-solid",
                  type: "text",
                  name: "email",
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
                  autocomplete: "off",
                  onKeyup: _withKeys(_ctx.onEnter, ["enter"])
                }, null, 8, ["modelValue", "onKeyup"]),
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode(_component_ErrorMessage, { name: "email" })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg form-control-solid",
                  type: "password",
                  name: "password",
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event)),
                  autocomplete: "off",
                  onKeyup: _withKeys(_ctx.onEnter, ["enter"])
                }, null, 8, ["modelValue", "onKeyup"]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _createVNode(_component_ErrorMessage, { name: "password" })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
                  ref: "submitButton",
                  id: "kt_sign_in_submit",
                  class: "btn btn-lg btn-primary w-100 mb-5",
                  style: {"background-color":"#c9115f"},
                  disabled: _ctx.isLoading
                }, [
                  _hoisted_15,
                  _hoisted_16
                ], 8, ["disabled"])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]),
      _hoisted_17
    ]),
    _createVNode(_component_RegisterAccountModalEC)
  ], 64))
}